import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "content-section col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "menu-icon",
  src: "/assets/icons/back-icon.svg"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Tillbaka ")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col respond-title-box" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "bold-primary" }, "Ämne:", -1)
const _hoisted_9 = {
  key: 0,
  class: "dezen-pro-regular margin-left"
}
const _hoisted_10 = {
  key: 1,
  class: "dezen-pro-regular margin-left"
}
const _hoisted_11 = { class: "dezen-pro-regular float-right" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = {
  key: 0,
  class: "col-4 respond-title-box"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "bold-primary" }, "Från:", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "dezen-pro-regular margin-left" }, "Ordna", -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "col respond-title-box" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "bold-primary" }, "Mottaget:", -1)
const _hoisted_19 = { class: "dezen-pro-regular margin-left" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = {
  class: "col respond-box-message",
  style: {"white-space":"pre-line"}
}
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "more-margin" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Uppskattad svarstid: Inom två timmar under vanliga arbetstider (måndag-fredag 08:00-18:00) ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "back-button message-title",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
    }, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          (_ctx.message.category)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.message.category), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.message.subject), 1)),
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.loanType(_ctx.message.loanType)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        (!_ctx.message.fromCustomer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.formatDate(_ctx.message.createdAt)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("p", {
            innerHTML: _ctx.message.message
          }, null, 8, _hoisted_22)
        ])
      ])
    ]),
    _createElementVNode("button", {
      class: "btn primary-button-send more-margin",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/message/add')))
    }, " Svara på meddelande "),
    _hoisted_23
  ]))
}